<template>
  <FiltersItemContent>
    <template #content>
      <div
        id="filter-slider-price"
        class="filtersSlider"
      >
        <h5 class="filtersSlider__title">
          <span>{{ $l('showresult.filter.priceTitle') }}</span>
        </h5>
        <div class="filtersSlider__value">
          <span /><span id="slider-price-text">{{ getSliderHeaderText }}</span>
        </div>
        <div class="sliderWrapper sliderWrapper--filter">
          <BaseSlider
            id="minMax-price-slider"
            v-model:modelValue="sliderValues"
            :config="sliderConfig"
            @update="sliderUpdateEvent"
          />
        </div>
      </div>
    </template>
  </FiltersItemContent>
</template>


<script setup>
import { l, lc } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();
const sliderValuesTranslated = ref(resultQueryStore.state.response.uniquePrices[resultQueryStore.state.response.uniquePrices.length - 1]);

const sliderConfig = computed(() => {
	return {
		connect: [true, false],
		range: {
			min: 0,
			max: resultQueryStore.state.response.uniquePrices.length - 1 || 1
		},
		handleAttributes: [
			{ 'aria-label': l('showresult.filter.priceTitle') }
		]
	};
});

const sliderValues = computed({
	get: () => {
		let lowestIndex = resultQueryStore.state.response.uniquePrices.length - 1;
		if (filtersStore.state.price) {
			const price = filtersStore.state.price;
			lowestIndex = resultQueryStore.state.response.uniquePrices.indexOf(price);
			if (lowestIndex === -1) {
				lowestIndex = resultQueryStore.state.response.uniquePrices.length - 1;
			}
		}
		return lowestIndex;
	},
	set: (values) => {
		sliderUpdateEvent(values);
		const [start] = values;
		if (start === resultQueryStore.state.response.uniquePrices.length - 1) {
			filtersStore.set({ key: 'price', value: null });
			return;
		}
		// check if last value is selected, set to null
		filtersStore.set({ key: 'price', value: sliderValuesTranslated.value });
	}
});

const getSliderHeaderText = computed(() => {
	return lc(sliderValuesTranslated.value);
});

const sliderUpdateEvent = (sliderValues) => {
	const [lowest] = sliderValues;
	sliderValuesTranslated.value = resultQueryStore.state.response.uniquePrices[lowest];
};

</script>
